import React from "react";
import useTailwindBrand from "../../../Theme/useTailwindBrand";
import ConsultationDesCours from "./ConsultationDesCours";

interface DetailCoursClientProps {
  eleve: string;
  matiere: string;
  startDatetime: string | Date;
  endDatetime: string | Date;
  duree: string;
  remuneration: string;
  acompte: string;
  statut: string;
  format: string;
  infos?: string;
  reste?: string;
  proofDeposit?: string;
  punctual?: string;
  invoice?: string;
  date?: number;
  isUrgent?: boolean;
  onOpenProposal?: () => void;
  clientID?: number;
  duration?: number;
  activeTab?: string;
}

const DetailCoursClient: React.FC<DetailCoursClientProps> = ({
  eleve,
  matiere,
  startDatetime,
  endDatetime,
  duree,
  remuneration,
  acompte,
  statut,
  format,
  infos,
  reste,
  proofDeposit,
  punctual,
  invoice,
  isUrgent,
  onOpenProposal,
  clientID,
  duration,
  activeTab
}) => {
  // const { classes } = useTailwindBrand();

  return (
    <>
      <div className="max-w-md mx-auto bg-white rounded-2xl shadow-md p-6 border border-gray-200 m-4">
        {/* <div className={`space-y-2 ${classes.text} ${classes.fontFamily}`}> */}
        <p>
          <strong>Élève :</strong> {eleve}
        </p>
        <p>
          <strong>Matière :</strong> {matiere}
        </p>
        <p>
          <strong>Date :</strong>{" "}
          {new Date(startDatetime)
            .toLocaleDateString("fr-FR", {
              day: "2-digit",
              month: "short",
              year: "numeric",
            })
            .replace(/\./g, "")}
        </p>
        <p>
          <strong>Durée :</strong> {duree}
        </p>
        <p>
          <strong>Format :</strong> {format}
        </p>
        <p>
          <strong>Type de cours :</strong>{" "}
          {isUrgent ? "Cours en urgence" : "Cours ponctuel"}
        </p>
      </div>
      <ConsultationDesCours
        punctualId={punctual ? Number(punctual) : 0}
        toggleRow={() => {}}
        activeRow={null}
        load={false}
        setLoad={() => {}}
        onOpenProposal={onOpenProposal}
        clientID={clientID}
        duration={duration}
        activeTab={activeTab}
      />
    </>
  );
};

export default DetailCoursClient;
